import "./notFound.css";
import { Player } from "@lottiefiles/react-lottie-player";
import notFoundLottie from "../../assets/lotties/not-found.json";
import { Helmet } from "react-helmet";


export const NotFound = () => {
    return (
        <>
            <Helmet>
                <title>SHOP.CO | Page Not Found (404)</title>
                <meta
                    name="description"
                    content="Oops! The page you are looking for does not exist. Return to SHOP.CO home to continue browsing our products."
                />
                <link
                    rel="canonical"
                    href="https://shop-co-roan.vercel.app/"
                />
            </Helmet>

            <div className="notFound-div">
                <Player
                    autoplay
                    loop
                    src={notFoundLottie}
                    className="notFound-animation"
                />
                <h1>404 - Page Not Found</h1>
                <p>Oops! The page you're looking for doesn't exist.</p>
            </div>
        </>
    );
};
